export default "__VITE_ASSET__DU_z8iPN__"